/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import LayoutModel from 'cio/models/layout';

interface PreviewCardArgs {
  item: LayoutModel;
  setDefaultAction: (item: LayoutModel) => unknown;
  disabled: boolean;
}

export default class PreviewCard extends Component<PreviewCardArgs> {}
